import {
  HrBlockContainer,
  HrButtons,
  HrFlexContainer,
  HrParagraph,
  HrTitleContainer,
  HrTitleH4
} from '@components/styles/hr-styles';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../modal';
import { DisplaySettingsContext } from '../../store/display-settings';

export const ModalShowErrors = ({ setShowModalShowErrors, setShowModalSuport, errrosForm }) => {
  const [t] = useTranslation();

  if (Object.values(errrosForm)?.length === 0) {
    setShowModalShowErrors(false);
    setShowModalSuport(true);
    return null;
  }

  const Errors = (errros) =>
    Object.values(errros).map((error, index) => (
      <HrParagraph
        fontSizeSetting={fontSizeSetting}
        color={darkMode ? 'white' : ''}
        padding='4px 0'
      >
        - {t(`postulant.modalErros.${Object.keys(errros)[index]}`)}:{' '}
        {error.message || 'Campos pendientes'}
      </HrParagraph>
    ));

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <Modal setShowModal={setShowModalShowErrors}>
      <HrTitleContainer padding='32px 24px 16px 24px' gap='4px'>
        <span style={{ color: darkMode ? 'white' : '' }} className='hr-Settings' />
        <HrTitleH4 color={darkMode ? 'white' : ''} fontSizeSetting={fontSizeSetting}>
          {t('postulant.modalErros.title')}
        </HrTitleH4>
      </HrTitleContainer>
      <HrBlockContainer padding='24px'>
        <HrParagraph color={darkMode ? 'white' : ''} fontSizeSetting={fontSizeSetting}>
          Aún tienes campos por completar, revisa bien tu postulación.
        </HrParagraph>
        {Object.values(errrosForm).length > 0 && Errors(errrosForm)}
      </HrBlockContainer>
      <HrFlexContainer flexDirection='column' padding='24px'>
        <HrFlexContainer justifyContent='space-between'>
          <HrButtons
            type='button'
            category='cancel'
            size='medium'
            style={{ fontSize: `${14 + fontSizeSetting || 0}px` }}
            onClick={() => {
              setShowModalShowErrors(false);
            }}
          >
            {t('general.button.cancel')}
          </HrButtons>
          <HrFlexContainer width='auto' gap='8px'>
            <HrButtons
              type='button'
              category='primary'
              size='medium'
              style={{ fontSize: `${14 + fontSizeSetting || 0}px` }}
              onClick={() => {
                setShowModalShowErrors(false);
                setShowModalSuport(true);
              }}
            >
              {t('postulant.modal.mini_support.button')}
            </HrButtons>
          </HrFlexContainer>
        </HrFlexContainer>
      </HrFlexContainer>
    </Modal>
  );
};
